import { MapPin, Landmark, Wine, Grape } from 'lucide-react';

const VILLAGE_IMAGES = [
  'https://images.unsplash.com/flagged/photo-1557263256-5c1f869cfd45?q=80&w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1762031732167-5c7a542805b6?q=80&w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1691943811341-b29580ded01e?q=80&w=800&auto=format&fit=crop',
  'https://images.unsplash.com/photo-1761228636830-8d189dbb8723?q=80&w=800&auto=format&fit=crop',
];

const highlights = [
  {
    icon: Landmark,
    title: 'Village historique',
    text: 'Cite medievale fortifiee, Riquewihr est classee parmi les Plus Beaux Villages de France. Ses maisons a colombages des XVe au XVIIIe siecle sont remarquablement preservees.'
  },
  {
    icon: Wine,
    title: 'Route des Vins',
    text: 'Au coeur de la Route des Vins d\'Alsace, entre Colmar et Selestat. Degustez les grands crus : Riesling, Gewurztraminer, Muscat et Pinot Gris.'
  },
  {
    icon: Grape,
    title: 'Cour Renaissance',
    text: 'Nos appartements se situent dans la Cour Renaissance, un ensemble architectural exceptionnel du XVIe siecle au 4, Rue du General De Gaulle.'
  },
  {
    icon: MapPin,
    title: 'A decouvrir',
    text: 'Marche de Noel feerique, vignobles a perte de vue, chateaux medievaux, gastronomie alsacienne. Colmar a 15 min, Strasbourg a 1h.'
  }
];

export default function DiscoverSection() {
  return (
    <section
      id="decouvrir"
      data-testid="discover-section"
      className="py-24 md:py-32 bg-earth-100 text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-5">
        <img
          src={VILLAGE_IMAGES[1]}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container mx-auto px-4 md:px-8 max-w-7xl relative z-10">
        <div className="text-center mb-16 md:mb-20">
          <p className="font-accent text-gold text-lg tracking-[0.2em] uppercase mb-4">
            Destination
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-white mb-6">
            Decouvrez Riquewihr
          </h2>
          <p className="font-body text-white/70 text-lg max-w-2xl mx-auto leading-relaxed">
            Perle du vignoble alsacien, Riquewihr vous transporte dans un decor de conte de fees
          </p>
        </div>

        {/* Image grid - asymmetric bento */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-20">
          <div className="col-span-2 row-span-2 overflow-hidden group">
            <img
              src={VILLAGE_IMAGES[0]}
              alt="Rue pittoresque de Riquewihr"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="overflow-hidden group">
            <img
              src={VILLAGE_IMAGES[2]}
              alt="Maisons a colombages"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="overflow-hidden group">
            <img
              src={VILLAGE_IMAGES[1]}
              alt="Vignobles d'Alsace"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="col-span-2 overflow-hidden group aspect-[2/1]">
            <img
              src={VILLAGE_IMAGES[3]}
              alt="Paysage viticole"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
        </div>

        {/* Highlights grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((h) => (
            <div
              key={h.title}
              data-testid={`discover-highlight-${h.title.toLowerCase().replace(/\s/g, '-')}`}
              className="group"
            >
              <div className="w-12 h-12 border border-gold/40 flex items-center justify-center mb-5 group-hover:bg-gold/10 transition-colors duration-300">
                <h.icon size={22} className="text-gold" />
              </div>
              <h3 className="font-display text-xl mb-3">{h.title}</h3>
              <p className="font-body text-sm text-white/60 leading-relaxed">{h.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
